import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 16px;
  gap: 8px;
  justify-content: space-around;
  align-items: center;
`;

